<!-- 用于从短信打开一个H5跳转betterwe app -->
<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    location.href =
      'betterwe://deepLink/main?path=/wmOtherPage?fromType=11&url=https%3A%2F%2F187447846.crm.n.weimob.com%2Fbos%2Fonecrm%2F187447846%2F6001490628846%2F2583529846%2Fcoupons%2Fcoupon-list%3Fvid%3D6001490628846%26productInstanceId%3D2583529846%26tracepromotionid%3D100081227%26tempTracepromotionid2%3D1703833576309&title=%E5%AE%89%E5%BF%83%E8%B4%AD'
    setTimeout(() => {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    }, 300)
  }
}
</script>
